<template>
  <v-card flat dense>
    <v-form ref="form" v-model="valid">
      <v-card-title>
        <span class="mr-4">
          {{ $t('ITEM.VIEW') }} {{ $t('BOOKING.RESERVATIONS.ITEM') }}
        </span>
        <v-spacer></v-spacer>
        <span class="text-body-2">{{ $t('ITEM.STATUS') }}</span>
        <div>
          <booking-reservations-status
            v-model="reservation.status_id"
            name="status_id"
            style="width: 140px"
            :lock-id="reservation.resource.lock_id"
            :error-messages="errors.status_id"
            @change="clearErrorByName('status_id')"
          />
        </div>
        <v-btn icon @click="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-subtitle v-if="errorsWithoutForm.length">
        <errors :errors="errorsWithoutForm" />
      </v-card-subtitle>
      <v-card-text>
        <booking-reservation-form
          v-if="reservation.id"
          v-model="reservation"
          :resource="reservation.resource"
          :errors="errors.getAll()"
          :action="view"
          @update-prop="clearErrorByName($event)"
        ></booking-reservation-form>
        <v-card-actions>
          <v-btn outlined depressed color="grey" @click="cancel">
            {{ $t('BUTTON.CANCEL') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn depressed color="primary" :disabled="!valid" @click="update">
            {{ $t('BUTTON.UPDATE') }}
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-form>
  </v-card>
</template>

<script>
import errors from '@/modules/_global/mixins/errors';
import Errors from '@/modules/_global/_components/Errors';
import BookingReservationForm from '../forms/BookingReservationForm';
import BookingReservationsStatus from '../forms/BookingReservationsStatus.vue';
import { mapActions } from 'vuex';
import { EDIT } from '@/modules/_global/mixins/form-editable.js';

export default {
  name: 'ViewReservation',

  components: {
    Errors,
    BookingReservationForm,
    BookingReservationsStatus
  },

  mixins: [errors],

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      valid: false,
      reservation: {
        resource: {
          lock_id: null
        }
      },
      view: EDIT
    };
  },

  computed: {
    errorsWithoutForm() {
      return ['resource_id', '_unexpected']
        .reduce((acc, i) => acc.concat(this.errors.get(i)), [])
        .filter(i => i);
    }
  },

  mounted() {
    this.getBookingReservation({ reservationId: this.id }).then(({ data }) => {
      this.reservation = data;
    });
  },

  methods: {
    ...mapActions('booking_reservations', [
      'getBookingReservation',
      'updateBookingReservation'
    ]),

    cancel() {
      this.$emit('cancel');
    },

    update() {
      this.updateBookingReservation({
        reservationId: this.id,
        reservation: this.reservation
      })
        .then(response => {
          this.$emit('updated', response.data);
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    }
  }
};
</script>
